import * as crypto from "crypto";

export const sha256 = (str) => {
    const hash = crypto.createHash("sha256");
    return hash.update(str).digest("hex");
}

